import { useCallback, useState } from "react";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { Box, Button, Typography } from "@mui/material";
import { DialogComponent } from "src/utils/GlobalModal/DialogComponent";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";
import { useMassAccept } from "src/Pages/Company/Pending/PendingBenefits/query";

export const MassActionAccept = () => {
  const [open, setOpen] = useState(false);
  const {
    getMassActionData,
    resetSelection,
    selectedAcceptableSalaryDeductionsCount,
    selectedAcceptableWaitingRoomsCount,
  } = useSelectedRows();

  const toAcceptCount =
    selectedAcceptableSalaryDeductionsCount +
    selectedAcceptableWaitingRoomsCount;

  const { isPending, mutate } = useMassAccept();

  const confirm = useCallback(() => {
    mutate(getMassActionData(true), {
      onSuccess: () => {
        resetSelection();
        dynamicNotification(__("Pomyślnie zaakceptowano"));
      },
      onError: () => {
        dynamicNotification(__("Nie udało się zaakceptować"), "error");
      },
      onSettled: () => {
        setOpen(false);
      },
    });
  }, [getMassActionData, mutate, resetSelection]);

  return (
    <>
      <Button
        color="success"
        size="small"
        variant="outlined"
        startIcon={<CheckCircleOutlinedIcon />}
        disabled={toAcceptCount === 0}
        onClick={() => setOpen(true)}
      >
        {__("Akceptuj zaznaczone")} {toAcceptCount > 0 ? toAcceptCount : ""}
      </Button>
      <DialogComponent
        isOpen={open}
        onClose={() => setOpen(false)}
        title={__("Akceptuj zaznaczone")}
        description={__("Te zmiany sa nieodwracalne")}
        actions={({ close }) => (
          <>
            <Button
              variant="outlined"
              color="inherit"
              disabled={isPending}
              onClick={close}
            >
              {__("Anuluj")}
            </Button>
            <Button
              variant="contained"
              color="success"
              loading={isPending}
              loadingPosition="start"
              onClick={confirm}
            >
              {__("Akceptuj")}
            </Button>
          </>
        )}
      >
        <Box sx={{ mb: 2 }}>
          {selectedAcceptableSalaryDeductionsCount > 0 && (
            <Box sx={{ mb: 1 }}>
              <Typography variant="body1">
                {__("Liczba akceptowanych zgód na potrącenie: {0}", [
                  selectedAcceptableSalaryDeductionsCount,
                ])}
              </Typography>
            </Box>
          )}
          {selectedAcceptableWaitingRoomsCount > 0 && (
            <Box sx={{ mb: 1 }}>
              <Typography variant="body1">
                {__("Liczba akceptowanych zamówień: {0}", [
                  selectedAcceptableWaitingRoomsCount,
                ])}
              </Typography>
            </Box>
          )}
        </Box>
      </DialogComponent>
    </>
  );
};
